import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable } from "rxjs";
import { BankIdStart, BankIdStatus } from "../../model/bankid";
import { APP_CONFIG, IAppConfig } from "../../../app.config";
import { MessageService } from "../../../core/service/message.service";
import { Inject, Injectable } from "@angular/core";

@Injectable()
export class BankIdService {
  constructor(
    private _client: HttpClient,
    private _notification: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/bank-id`;
  }

  private readonly _endpoint: string;

  bankIdAuthStart(isMobile: boolean, thisUnit: boolean): Observable<BankIdStart> {
    return this._client.post<BankIdStart>(`${this._endpoint}/bankid-start`, { isMobile, thisUnit }).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this._notification.showError(errorResponse.error.message);
        }
        throw errorResponse;
      })
    );
  }

  getBankTransactionCount(): Observable<any> {
    return this._client.get(`${this._endpoint}/definition`);
  }

  bankIdAuthStatus(isMobile: boolean, thisUnit: boolean, orderReference: string): Observable<BankIdStatus> {
    return this._client.post<BankIdStatus>(`${this._endpoint}/bankid-status`, { isMobile, thisUnit, orderReference }).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this._notification.showError(errorResponse.error.message);
        }
        throw errorResponse;
      })
    );
  }

  bankIdCancel(orderReference: string): Observable<void> {
    return this._client.post<void>(`${this._endpoint}/bankid-cancel`, { orderReference });
  }
}